import { render, staticRenderFns } from "./register-step.vue?vue&type=template&id=26988248&scoped=true&lang=pug&"
import script from "./register-step.vue?vue&type=script&lang=js&"
export * from "./register-step.vue?vue&type=script&lang=js&"
import style0 from "./register-step.vue?vue&type=style&index=0&id=26988248&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26988248",
  null
  
)

export default component.exports